import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { IconComponent } from '@uigy/shared/components/icons/icon/icon.component';
import { NgClass } from '@angular/common';
import { BadgeConfig } from '@uigy/shared/components/ui-badge/ui-badge.interfaces';

@Component({
    selector: 'app-ui-badge',
    imports: [
        IconComponent,
        NgClass,
    ],
    templateUrl: './ui-badge.component.html',
    styleUrl: './ui-badge.component.scss',
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class UiBadgeComponent {
  public badgeConfig = input.required<BadgeConfig>();
  public isDisabled = input<boolean>(false);
  public isLoading = input<boolean>(false);
  public isResponsive = input<boolean>(false);

  public getBadgeSize(): string {
    return this.badgeConfig().size ?? '';
  }
}
